// extracted by mini-css-extract-plugin
export default {"title":"view_title__RFAkL","subtitle":"view_subtitle__uPM53","ellipsis":"view_ellipsis__Z0mvR","font11":"view_font11__6D55D"};